/* Das Coeur - cart-side race list proof + editor. Loaded once by main-cart-items.

   NOTE 1: changing a line item's properties changes its line item KEY on the
   server (the key is derived from the variant plus the properties). After a
   successful save the key held in the DOM is stale, and the Liquid-rendered
   "Race List:" text above the panel still shows the old value. Both are fixed
   by reloading the page after a save - don't "optimise" that away.

   NOTE 2: there is deliberately no enlarge/zoom control. Resizing the panel at
   runtime does not reflow inside Dawn's cart table (verified: both a CSS class
   and an inline style.width were ignored). A bigger view needs a fixed-position
   overlay outside the table.

   NOTE 3: do not use document.fonts.ready to trigger the re-fit. A font is only
   requested when first used, so fonts.ready can resolve BEFORE Graduate has
   loaded and the text then gets sized against the fallback and overflows.
   Use document.fonts.load('16px "Graduate"') instead. */
(function(){
  var MAXFIT = 220;
  var PRINT_FONT = '16px "Graduate"';

  function titleCase(s){
    return s.toLowerCase().replace(/(^|[\s\-\/(])([a-z0-9])/g, function(m,p,c){ return p + c.toUpperCase(); });
  }

  function clean(raw, maxLines){
    var lines = String(raw || '').split(/\r?\n/).map(function(l){
      return l.replace(/\s+/g,' ').trim();
    }).filter(function(l){ return l.length > 0; });
    return { lines: lines.slice(0, maxLines), overflow: Math.max(0, lines.length - maxLines) };
  }

  function fit(box, text){
    var maxW = box.clientWidth, maxH = box.clientHeight;
    if (!maxW || !maxH) return;
    var lo = 3, hi = MAXFIT, best = 3;
    while (lo <= hi){
      var mid = Math.floor((lo + hi) / 2);
      text.style.fontSize = mid + 'px';
      if (text.offsetWidth <= maxW && text.offsetHeight <= maxH){ best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    text.style.fontSize = best + 'px';
  }

  function init(root){
    if (root.dataset.dcReady === '1') return;
    root.dataset.dcReady = '1';

    var key      = root.dataset.key;
    var maxLines = parseInt(root.dataset.maxLines, 10) || 20;
    var maxChars = parseInt(root.dataset.maxChars, 10) || 26;

    var box     = root.querySelector('[data-dc-print]');
    var text    = root.querySelector('[data-dc-text]');
    var summary = root.querySelector('[data-dc-summary]');
    var toggle  = root.querySelector('[data-dc-toggle]');
    var editor  = root.querySelector('[data-dc-editor]');
    var input   = root.querySelector('[data-dc-input]');
    var count   = root.querySelector('[data-dc-count]');
    var msg     = root.querySelector('[data-dc-msg]');
    var ok      = root.querySelector('[data-dc-ok]');
    var save    = root.querySelector('[data-dc-save]');
    var cancel  = root.querySelector('[data-dc-cancel]');
    if (!box || !text || !input) return;

    var saved = input.value;

    function paint(raw){
      var res = clean(raw, maxLines);
      text.textContent = res.lines.map(titleCase).join('\n');
      if (res.lines.length) fit(box, text);
      if (summary) summary.textContent = res.lines.length + (res.lines.length === 1 ? ' race' : ' races');
      return res;
    }

    function onType(){
      var res = paint(input.value);
      if (count) count.textContent = res.lines.length + ' of ' + maxLines;
      var problems = [];
      if (res.overflow > 0) problems.push('Only the first ' + maxLines + ' will print.');
      var long = res.lines.filter(function(l){ return l.length > maxChars; });
      if (long.length) problems.push(long.length + (long.length === 1 ? ' line is' : ' lines are') + ' long and will print small.');
      if (msg){ msg.textContent = problems.join(' '); msg.hidden = problems.length === 0; }
      if (ok) ok.hidden = true;
    }

    function open(){ editor.hidden = false; toggle.hidden = true; input.focus(); }
    function close(){ editor.hidden = true; toggle.hidden = false; }

    toggle.addEventListener('click', open);
    input.addEventListener('input', onType);

    cancel.addEventListener('click', function(){
      input.value = saved;
      onType();
      if (msg) msg.hidden = true;
      close();
    });

    save.addEventListener('click', function(){
      var res = clean(input.value, maxLines);
      if (!res.lines.length){
        if (msg){ msg.textContent = 'Add at least one race.'; msg.hidden = false; }
        return;
      }
      var value = res.lines.join('\n');
      save.disabled = true;
      save.textContent = 'Saving...';
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, properties: { 'Race List': value } })
      })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(){ window.location.reload(); })
      .catch(function(){
        if (msg){ msg.textContent = 'Could not save - please reload the page and try again.'; msg.hidden = false; }
        save.disabled = false;
        save.textContent = 'Save';
      });
    });

    paint(saved);
    onType();
    if (msg) msg.hidden = true;

    if (document.fonts && document.fonts.load){
      document.fonts.load(PRINT_FONT).then(function(){ paint(input.value); }).catch(function(){});
    }
  }

  function initAll(){ document.querySelectorAll('[data-dc-cart]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('cart:refresh', initAll);
})();
